export default __webpack_public_path__ + "static/media/AllowanceImg.47204be1.jpg";